import Button from 'app/components/Button';
import Loading from 'app/components/Loading';
import Modal from 'app/components/Modal';
import React, { useRef } from 'react';
import style from './AddressSelectModal.module.scss';

type AddressSelectModalProps = {
  open?: boolean;
  isLoading?: boolean;
  email?: string;
  list?: Array<any>;
  onSuccess?: (...args: any[]) => void;
};

const AddressSelectModal = ({
  open,
  email,
  list,
  onSuccess,
  isLoading,
}: AddressSelectModalProps) => {
  const className = 'c-AddressSelectModal';
  const selectRef = useRef<any>();

  const onBtnClick = () => {
    onSuccess?.({ ref: selectRef.current });
  };

  return (
    <Modal
      open={open}
      onClose={() => {}}
      showCloseIcon={false}
      customContainerClass={style[`${className}__modal`]}
    >
      <div className={style[className]}>
        <p className={style[`${className}__title`]}>
          A different wallet address?
        </p>
        <p className={style[`${className}__body`]}>
          We detected that the wallet address you’ve registered using your email
          is as follows, would you like to use the below wallet address instead?
        </p>
        {/* <p className={style[`${className}__info`]}>
          <span>Email</span>
          dhruv@nasacademy.com
        </p> */}
        <div className={style[`${className}__dropdown`]}>
          <p className={style[`${className}__dropdown__label`]}>
            Select an address and connect the same from metamask -
          </p>
          <select
            className={style[`${className}__dropdown__select`]}
            ref={selectRef}
          >
            {list?.map((address, index) => (
              <option key={index} value={address}>
                {address}
              </option>
            ))}
          </select>
        </div>
        <div className={style[`${className}__cta`]}>
          {/* @ts-ignore */}
          <Button displayType="primary" onClick={onBtnClick}>
            Continue
          </Button>
        </div>
        {isLoading && (
          <div className={style[`${className}__loading`]}>
            <Loading />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default AddressSelectModal;
